// extracted by mini-css-extract-plugin
export default {"wrap":"error-module_wrap_CduXb","title":"error-module_title_wap0h","content":"error-module_content_MOw98"};